<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="isScreenAccessible else screenNotAccessible" style="overflow: auto;">
    <app-my-skill-verifications-list #skillAckPanel 
    [showLoader] = "showLoader" 
    [skillVerifications]=skillVerifications
    [isShowCheckbox]=displayShowAllButton 
    [enableInActiveLabel]=displayShowAllLabel 
    (checkboxSelection)="getSkillVerificationListDate($event)" 
    [showInformationIconCheckbox]=showInformationIconCheckbox 
    [informationIconTooltip]="showAllTooltip" 
    [checkboxLabel]="showAllLabel"
    (reloadMySkillVerifications)="getSkillVerificationListDate($event)">
    </app-my-skill-verifications-list>
</div>
<ng-template #screenNotAccessible>
    <app-error [errorMessage]="errorMessage"></app-error>
  </ng-template>